var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.width }),attrs:{"options":_vm.regionOptions,"props":_vm.cascaderProps,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"clearable":"","filterable":""},on:{"change":_vm.handleChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }